import * as React from 'react'

import { appHref } from '@/config/config'
import { trackMarketingCta } from '@/lib/analytics'
import { withCrossDomainIds } from '@/lib/crossDomainTracking'
import { ESTIMATE_BANNER_COPY } from '../content/estimateBannerCopy'
import { EstimateBanner } from './EstimateBanner'

export function HomeEstimateBanner() {
  const [triggered, setTriggered] = React.useState(false)
  const [dismissed, setDismissed] = React.useState(false)

  React.useEffect(() => {
    if (triggered) return

    const productsEl = document.getElementById('products')
    if (!productsEl) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTriggered(true)
          observer.disconnect()
        }
      },
      { threshold: 0.1 }
    )

    observer.observe(productsEl)
    return () => observer.disconnect()
  }, [triggered])

  // Auto-dismiss once the footer comes into view — the same form lives there
  // permanently, so the floating copy has taught its lesson and steps aside
  // instead of overlapping it.
  React.useEffect(() => {
    if (dismissed) return

    const footerEl = document.querySelector('[data-site-footer]')
    if (!footerEl) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setDismissed(true)
          observer.disconnect()
        }
      },
      { threshold: 0.3 }
    )

    observer.observe(footerEl)
    return () => observer.disconnect()
  }, [dismissed])

  return (
    <EstimateBanner
      open={triggered && !dismissed}
      onDismiss={() => setDismissed(true)}
      onSubmit={(dot) => {
        trackMarketingCta('estimate_banner_floating', {
          dot_provided: Boolean(dot),
          dot_number: dot || undefined,
        })
        window.location.href = withCrossDomainIds(appHref(`/insurance/start${dot ? `?dot=${dot}` : ''}`))
      }}
      {...ESTIMATE_BANNER_COPY}
    />
  )
}
